module.exports = __webpack_public_path__ + "static/media/reportsDone.e6669ff0.png";